import { LoadingSpinner } from "@bluefalcon/components-package";
import { State, StateUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { Box, Button, Flex, Table, TableCaption, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { stateService } from "../../services";
import { Link } from "react-router-dom";

type StatesTableProps = {

};

export const StatesTable = ({

}: StatesTableProps) => {

    const [states, setStates] = useState<State[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchStates = async () => {
        setIsLoading(true);
        try {
            const states = await stateService.getStates();
            setStates(states);
            setTotal(states.length);
        } catch (error) { } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchStates();
    }, []);

    const onUpdateState = async (id: string, req: StateUpdateRequest) => {
        try {
            await stateService.updateStateById(id, { ...req });
            fetchStates();
        } catch (error) { } finally {
            // onClose();
        }
    };

    if (!isLoading && total === 0) {
        return (
            <Box textAlign={'center'} mt={4}>
                No states found.
            </Box>
        )
    }

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Table variant="simple">
                <TableCaption textAlign={'left'}>Total States: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {states.map((state) => (
                        <Tr key={state.id}>
                            <Td>{state.id}</Td>
                            <Td>{state.name}</Td>
                            <Td>
                                <Flex>
                                    <Button to={`/states/${state.id}`} mr={2} size="sm" as={Link}>
                                        Details
                                    </Button>
                                </Flex>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </>
    )
};
